/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:7d567fd8-1b1e-474c-a4e6-0fba284d6777",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_syWgeUluV",
    "aws_user_pools_web_client_id": "57o4r6hudv7npile6fdrog27ek",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://d4yl6g3swfcvta6pqbihli27x4.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
